var render, staticRenderFns
import script from "./map_form_customer.vue?vue&type=script&lang=js"
export * from "./map_form_customer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57c725f0')) {
      api.createRecord('57c725f0', component.options)
    } else {
      api.reload('57c725f0', component.options)
    }
    
  }
}
component.options.__file = "found/views/sfa/views/attendance_manage/sign_group/form/components/map_form_customer.vue"
export default component.exports